import { createPermission } from '@backstage/plugin-permission-common';

export const costReadPermission = createPermission({
  name: 'platform.cost.read',
  attributes: { action: 'read' },
});
